import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";

import {
  SUBJECT_BASED_GRADING,
  COURSE_BASED_GRADING,
} from "Constants/stringConstants";

export const ARCHIVAL_STATE_OPTIONS = [
  {
    id: "ALL",
    label: "common:all",
  },
  {
    id: "ACTIVE",
    label: "common:active",
  },
  {
    id: "ARCHIVED",
    label: "common:archived",
  },
];

export const CREATE_STEPS = [
  {
    id: "STANDARD_SET_SELECTION",
  },
  {
    id: "STANDARDS_SELECTION",
  },
];

export const EDIT_STEPS = [
  {
    id: "STANDARDS_SELECTION",
  },
];

export const FEED_LIST_COLUMN_LIST = [
  {
    key: "NAME",
    value: "common:name",
    style: {
      minWidth: "320px",
      maxWidth: "320px",
      backgroundColor: "var(--surface-secondary-enabled)",
    },
  },
  {
    key: "GRADE_SCALES",
    value: "academicSetup:grade_scales",
    style: {
      width: "100%",
      backgroundColor: "var(--surface-secondary-enabled)",
    },
  },
  {
    key: "ACTIONS",
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: "80px",
      backgroundColor: "var(--surface-secondary-enabled)",
    },
  },
];

export const SEARCH_LABELS = {
  STANDARD_SET_SELECTION: "scopeAndSequence:standard_set",
  STANDARDS_SELECTION: "common:standard",
};

export const FILTERS = {
  [COURSE_BASED_GRADING]: ["grades", "subjects", "tags", "archivalState"],
  [SUBJECT_BASED_GRADING]: ["grades", "tags", "archivalState"],
  null: ["grades", "tags", "archivalState"],
};

export const DEFAULT_STANDARD_FILTERS = {
  grades: [],
  subjects: [],
  tags: [],
  archivalState: "ACTIVE",
};

export const STANDARD_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.SELECTION,
  DATA_GRID_COLUMN_TYPES.CODE,
  DATA_GRID_COLUMN_TYPES.TITLE,
  DATA_GRID_COLUMN_TYPES.LIST_PARENT,
  DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
];

export const DATA_GRID_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.SELECTION,
  DATA_GRID_COLUMN_TYPES.CODE,
  DATA_GRID_COLUMN_TYPES.TITLE,
  DATA_GRID_COLUMN_TYPES.ID,
  DATA_GRID_COLUMN_TYPES.LIST_PARENT,
  DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  DATA_GRID_COLUMN_TYPES.TAGGED_IN_UNITS,
  DATA_GRID_COLUMN_TYPES.TAGGED_IN_ASSIGNMENTS,
  DATA_GRID_COLUMN_TYPES.TAGGED_IN_PORTFOLIO,
  DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
  DATA_GRID_COLUMN_TYPES.GRADING_TYPE,
  DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS,
  DATA_GRID_COLUMN_TYPES.TAGS,
  DATA_GRID_COLUMN_TYPES.DESCRIPTION,
  DATA_GRID_COLUMN_TYPES.ARCHIVE,
];

export const NON_CONFIGURABLE_COLUMNS = {
  start: [
    DATA_GRID_COLUMN_TYPES.SELECTION,
    DATA_GRID_COLUMN_TYPES.CODE,
    DATA_GRID_COLUMN_TYPES.TITLE,
  ],
};

export const DEFAULT_HIDDEN_COLUMNS = [
  DATA_GRID_COLUMN_TYPES.ID,
  DATA_GRID_COLUMN_TYPES.TAGGED_IN_UNITS,
  DATA_GRID_COLUMN_TYPES.TAGGED_IN_ASSIGNMENTS,
  DATA_GRID_COLUMN_TYPES.TAGGED_IN_PORTFOLIO,
  DATA_GRID_COLUMN_TYPES.GRADING_TYPE,
  DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS,
  DATA_GRID_COLUMN_TYPES.TAGS,
  DATA_GRID_COLUMN_TYPES.DESCRIPTION,
  DATA_GRID_COLUMN_TYPES.ARCHIVE,
];

export const STANDARD_PLANNER_ELEMENT_TYPE_ENUM = {
  IB_PYP: "PYP_LEARNING_STANDARD",
  IB_MYP: "MYP_LEARNING_STANDARD",
  UBD: "UBD_LEARNING_STANDARD",
  IB_DP: "DP_SUBJECT_STANDARD",
};

export const DATA_SCOPE_ENUM = {
  ALL: "ALL",
  UNIT: "UNIT",
  LEARNING_COURSE: "LEARNING_COURSE",
};
